<template>
  <router-view />
</template>

<script>
export default {
  name: "Contents",
  data() {
    return {};
  }
};
</script>

<style scoped>
</style>